import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import styles from './styles';

export interface TitleBehaviorProps {
  title: string;
  subtitle?: string;
  overrideClasses?: any;
}

const TitleBehavior = ({
  title,
  subtitle,
  overrideClasses,
}: TitleBehaviorProps) => {
  const classes = makeStyles(styles(overrideClasses))();

  return (
    <React.Fragment>
      <Grid
        className={classes.wrapper}
        item
        xs={12}
        data-testid={'autosky-titlebehavior'}
      >
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
        {subtitle && (
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default TitleBehavior;
